import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dea5bcc8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=dea5bcc8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea5bcc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dea5bcc8')) {
      api.createRecord('dea5bcc8', component.options)
    } else {
      api.reload('dea5bcc8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dea5bcc8&scoped=true", function () {
      api.rerender('dea5bcc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/alliance/promoter/index.vue"
export default component.exports